import { React } from 'react'

import MainHeader from '../../components/MainHeader/MainHeader'
import MainFooter from '../../components/MainFooter/MainFooter'
import CTAButton from '../../components/CTAButton/CTAButton'

import './Page404.css'
import './MPage404.css'
import '../../main.css'

import { lP } from '../../main.js'

export default function Page404() {

    return (
        <div className='mainCon page' id='mainCon'>
            <MainHeader pagetitle="" hideProfile={false} hideMenu={false} />
            <main className='page-body'>
                <section className='container section page404-section'>
                    <h1>Irren ist menschlich.</h1>
                    <h2>ERROR 404 - Seite nicht gefunden</h2>
                    <div className='infocontainer'>
                        <p>
                            Kehre entweder zur vorherigen Seite oder zur <a href="/">Startseite</a> zurück.<br />
                            Sollte der Fehler erneut auftreten, kontaktiere uns bitte.<br />
                            Am besten erreichst du uns über unseren Kontaktbereich<br />
                            oder alternativ direkt hier per Mail an <a href="mailto:info@helferzeit.de">info@helferzeit.de</a>.<br />
                            Wir stehen dir gerne zur Seite 😉
                        </p>
                    </div>
                    <br />
                    <CTAButton variant="primary" title="Zur Startseite" onclick={() => lP('/')} />
                </section>
            </main>
            <MainFooter />
        </div>
    )
}
